var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32049 13.7217L7.90049 12.3117L9.32049 10.8917L10.7305 12.3117L12.1405 10.8917L10.7305 9.48175L12.1405 8.07175L13.5605 9.48175L14.9705 8.07175L12.1405 5.24175L5.07049 12.3117L7.90049 15.1417L9.32049 13.7217ZM1.25049 17.5417L4.37049 14.4317L2.25049 12.3117L12.1405 2.41175L14.2705 4.54175L15.6705 3.12175L14.2705 1.70175L15.6705 0.291748L19.9205 4.54175L18.5105 5.94175L17.0905 4.54175L15.6705 5.94175L17.8005 8.07175L7.90049 17.9617L5.78049 15.8417L1.25049 20.3817V17.5417Z",
    fill: "#1D2951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4971,
    height: 20.4971,
    fill: "white",
    transform: "translate(0.251465 0.251465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTask);
export default __webpack_public_path__ + "static/media/bx_task.7eca170feeb5d511a0817f338ff09070.svg";
export { ForwardRef as ReactComponent };